<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Historical Tracking Filter</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>
    
<ion-content>
    <ion-list>
        <ion-item color="secondary">
            Select which trips you want to review by adjusting the following parameters.
        </ion-item>
    
        <ion-item data-test="startingDateItem" detail="true" (click)="onFilterStartingDateClick()" href="javascript:;">
            <ion-label>
                <span class="line1">Starting Trip Date</span><br />
                <span class="line2">{{vm.filter.startingDate | myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="endingDateItem" detail="true" (click)="onFilterEndingDateClick()" href="javascript:;">
            <ion-label>
                <span class="line1">Ending Trip Date</span><br />
                <span class="line2">{{vm.filter.endingDate | myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="selectedDriversItem" detail="true" (click)="onSelectDriversClick()" href="javascript:;">
            <ion-label>
                <span class="line1">Selected Drivers</span><br />
                <span class="line2">{{vm.filter.selectedDrivers}}</span>
            </ion-label>
        </ion-item>

        <!-- <ion-item lines="none">
            <ion-label class="ion-text-wrap">
                <span class="line1">Minimum Trip Duration Minutes: {{filter.minimumTripDurationMins}}</span>
            </ion-label>
        </ion-item> -->
<!-- 
        <ion-item>
            <ion-range class="insetRange" min="0" max="240" step="5" snaps="true" name="minimumTripDurationMins"
                [(ngModel)]="filter.minimumTripDurationMins" color="primary">
                <ion-label class="ion-text-wrap" color="primary" slot="start">0</ion-label>
                <ion-label class="ion-text-wrap" color="primary" slot="end">240</ion-label>
            </ion-range>
        </ion-item> -->

    </ion-list>

</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button data-test="nextButton" [disabled]=vb.disabled title="Next" (click)="onNextClick()">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
    <!-- <ion-toolbar>
        <ion-button color="secondary" [disabled]=vb.disabled expand="full" (click)="onGetTripsClick()">
            Get Trips
        </ion-button>
    </ion-toolbar> -->
</ion-footer>